const textUnderlinePositionUnder = {
    textUnderlinePosition: 'under',
};

const textDecorationSkipInkNone = {
    textDecorationSkipInk: 'none',
};

export default {textUnderlinePositionUnder, textDecorationSkipInkNone};
